<template>
  <div class="container-fluid">
    <div class="modal fade" id="setCollectionModal" tabIndex="-1" aria-labelledby="setCollectionModalTittle"
         aria-hidden="true">
      <div class="modal-dialog  modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createProjectModalTitle">Set a collection attachment</h5>
            <button type="button" id="closeAddCollectionModalButton" class="close" data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                <label>Collection to set ?</label>
                <div class="input-group">
                  <select class="custom-select" id="collectionNameSelection" v-model="collectionNameSelection">

                    <option>Choose a collection...</option>
                    <option v-for="collection of selectedProjectCollections" :key="collection">{{ collection }}</option>

                  </select>
                </div>
              </div>
              </div>
              <hr>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Abort</button>
                <button type="button" class="btn btn-primary" v-on:click="onSetCollectionSubmit()">Set collection
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>


      <div class="row row-cols-1"
           :class="{ 'row-cols-lg-2': ['byDefault', '2'].includes(columns), 'row-cols-lg-3': ['3'].includes(columns), 'row-cols-xxl-2': ['2'].includes(columns), 'row-cols-xxl-3': ['byDefault', '3'].includes(columns) }">
        <div class="p-2 tableCard" v-for="table in tables" :key="table.id" v-bind:id="'projectTableCard-'+table.id">
          <div class="card rounded-3 shadow-sm rounded col-12">

            <div class="card-header pr-1 pl-1 bg-transparent d-inline-block text-truncate border-light">

              <div class="row align-items-center">
              <span data-bs-toggle="tooltip" data-bs-placement="top"
                    :title="table.name" class="col-11 text-left text-truncate text-dark">{{ table.name }}</span>
                <a title="Delete" class="col close float-right" v-on:click="$emit('delete-table', table.id )"></a>
              </div>

            </div>
            <div class="card-body pb-1">
              <p class="card-title text-left"><strong>Path: </strong><span class="float-right">{{ table.path }}</span>
              </p>
              <div class="card-text text-left mb-2" :style="{'min-height': '24px'}">
                <div class="float-left">
                  <strong class="float-left" style="margin-top:3px">Status: </strong>
                </div>
                <StatusComponent class="float-right pb-0 pt-0 mb-0" :status="table.status"
                                 style="max-width: calc(51*1vw)"></StatusComponent>
                <!--
                              <statusDisplayer :status="table.status" class="align-items-center float-right pb-0 pt-0 mb-0 mr-0"></statusDisplayer>
                -->

              </div>

              <div class="card-text text-left mb-2" :style="{'min-height': '24px'}">

                <div v-if="table.projectCollection">
                  <p class="card-title text-left">
                    <strong>Collection: </strong>
                    <span class="float-right">
                  <span class="row mx-auto">
                    <span class="border border-600 rounded my-auto row mr-0 ml-0 pr-1 pl-1">
                      <span class="my-auto mr-1">{{ table.projectCollection }}</span>
                      <span href="#" class="my-auto icon icon-delete clickable"
                            v-on:click="$emit('delete-collection-in-table', signedUser, selectedProjectId, table.id, table.projectCollection  )"></span>
                    </span>
                  </span>
                  </span>
                  </p>
                </div>
                <div v-else>
                  <p class="card-title text-left"><strong>No collection </strong></p>
                </div>
              </div>

              <div class="float-right d-flex flex-row mt-1 mb-1">
                <button type="button" class="btn btn-sm btn-primary rounded " v-on:click="$emit('select-table',table )"
                        :class="{'disabled': isDetailButtonDisabled(table)}"
                        :title="isDetailButtonDisabled(table) ? 'No more details for this table status' : 'Details'">
                  Details
                </button>

                <div class="position-relative" :id="'dropdownBoundaryContainer-'+table.id">

                  <a :id="'tableAnalysisActionLauncher-'+table.id"
                     class="position-relative my-auto mb-4 mt-3 ml-2 btn btn-sm btn-secondary rounded"
                     :data-boundary="'dropdownBoundaryContainer-'+table.id" data-toggle="dropdown" aria-haspopup="true"
                     aria-expanded="false" :style="{'height': '30px'}">
                    <span class="mr-2 d-none d-md-inline-block">Start Actions</span>
                    <span class="icon icon-More-dots mr-0" :style="{'transform': 'rotate(90deg)'}"></span>
                  </a>

                  <a :ref="'linkSetCollectionsEditor-'+table.id" class="d-none" data-toggle="modal"
                     data-target="#setCollectionModal"></a>

                  <ul class="dropdown-menu dropdown-menu-right mt-0 mb-1" role="menu"
                      :aria-labelledby="'tableAnalysisActionLauncher-'+table.id">
                    <div class="px-1 py-1">
                      <div :title="'set collection name'">
                        <li v-if="table.projectCollection" href="#" class="dropdown-item btn btn-sm" :active="false"
                            :class="{'disabled': false}"
                            v-on:click="openCollectionsEditor(table)">Change collection attachment
                        </li>
                        <li v-if="!table.projectCollection" href="#" class="dropdown-item btn btn-sm" :active="false"
                            :class="{'disabled': false}"
                            v-on:click="openCollectionsEditor(table)">Set collection
                        </li>
                      </div>
                      <div
                          :title="launchOrRestartPreprocessingForbidden(table) ? launchOrRestartPreprocessingForbiddenCause(table) : launchOrRestartPreprocessingButtonText(table)">
                        <li href="#" class="dropdown-item btn btn-sm" v-on:click="onStartTablePreProcessing(table)"
                            :active="false" :class="{'disabled': launchOrRestartPreprocessingForbidden(table) }">
                          {{ launchOrRestartPreprocessingButtonText(table) }}
                        </li>
                      </div>
                      <div
                          :title="launchOrRestartAnnotationForbidden(table) ? launchOrRestartAnnotationForbiddenCause(table) : launchOrRestartAnnotationButtonText(table)">
                        <li href="#" class="dropdown-item btn btn-sm" v-on:click="onStartTableAnnotation(table)"
                            :active="false" :class="{'disabled': launchOrRestartAnnotationForbidden(table) }">
                          {{ launchOrRestartAnnotationButtonText(table) }}
                        </li>
                      </div>
                    </div>
                  </ul>

                </div>

              </div>
            </div>
            <div class="card-footer">
              <p class="card-text text-left text-muted"><small>Created the {{ table.creationDate.slice(0, 10) }}</small>
              </p>
            </div>

          </div>
        </div>
      </div>

    </div>

</template>
<script>
import Flip from '../../utils/Flip';
// import StatusDisplayer from './StatusDisplayer';
import StatusComponent from './content/StatusComponent';
import TableApi from '../../generatedApiClient/api/endpoints/TableApi';
let tableApiInstance = new TableApi();

export default {
  name: "CardsTables",
  props: ["tables", "columns"],
  components: {
    StatusComponent
  },
  data() {
    return {
      flip: new Flip(),
      updateType: undefined,
      collectionNameSelection: "Choose a collection...",
      setCollectionModalTable: undefined
    }
  },
  updated: function () {
    if (this.updateType === "tables") {
      let newTables = Array.from(document.querySelectorAll('.tableCard'));
      this.flip.play(newTables);
      this.flip = new Flip();
    }
  },
  computed: {
    signedUser: function () {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
    selectedProjectId: function () {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.id : undefined;
    },
    selectedProjectCollections: function () {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.collections : undefined;
    },
  },
  watch: {
    tables(val, oldVal) {
      console.log(`[watch] [tables] update ${(val && oldVal) ? '' : 'with missing value'}`);
      let existingTables = Array.from(document.querySelectorAll('.tableCard'));
      this.flip.read(existingTables);
      this.updateType = "tables";
    },
    columns(val, oldVal) {
      console.log(`[watch] [columns] update ${(val && oldVal) ? '' : 'with missing value'}`);
      this.updateType = "columns";
    }
  },
  methods: {
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    onSetCollectionSubmit: function () {
      this.updateAuthJwtToken(tableApiInstance);
      if (this.collectionNameSelection !== "Choose a collection...") {
        tableApiInstance.patchTable(this.signedUser, this.selectedProjectId, this.setCollectionModalTable.id,{
          "projectCollection":this.collectionNameSelection
        }  )
            .then(patchTableResp => {
              console.log("[onSetCollectionSubmit] [API] [patchTableResp] [OK]" + patchTableResp);
              this.emitRefreshTables();
              document.getElementById('closeAddCollectionModalButton').click();

            })
            .catch(patchTablError => {
              console.log("[onSetCollectionSubmit] [API] [patchTableResp] [ERROR]", patchTablError);
            });
      }
    },
    emitRefreshTables: function() {
      this.$emit('refresh-table', {});
    },
    openCollectionsEditor: function (table) {
      this.setCollectionModalTable = table;
      const links = this.$refs['linkSetCollectionsEditor-' + table.id];
      console.log(links.length);
      if ((links) && (links.length > 0)) {
        links[0].click();
      }

    },
    isDetailButtonDisabled: function (table) {
      return ((table === undefined) || ['UPLOADED', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED'].includes(table.status))
    },
    launchOrRestartPreprocessingButtonText: function (table) {
      if ((table === undefined) || ['UPLOADED', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED'].includes(table.status)) {
        return 'Start PreProcessing';
      } else {
        return 'Restart PreProcessing';
      }
    },
    launchOrRestartAnnotationButtonText: function (table) {
      if ((table === undefined) || ['UPLOADED', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED', 'PRE PROCESSING IN PROGRESS', 'PRE PROCESSING DONE', 'ANNOTATION IN ERROR', 'ANNOTATION FAILED'].includes(table.status)) {
        return 'Start Annotation';
      } else {
        return 'Restart Annotation';
      }
    },
    launchOrRestartPreprocessingForbidden(table) {
      return !table.isTableFileStillExisting;
    },
    launchOrRestartPreprocessingForbiddenCause() {
      return 'Forbidden: uploaded file is missing';
    },
    launchOrRestartAnnotationForbidden(table) {
      return ['UPLOADED', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED', 'PRE PROCESSING IN PROGRESS'].includes(table.status) && !table.isTableFileStillExisting;
    },
    launchOrRestartAnnotationForbiddenCause() {
      return 'Forbidden: uploaded file is missing';
    },
    onStartTablePreProcessing: function (table) {
      console.log("[onStartTablePreProcessing] -~~-> launch-preprocessing");
      this.$emit('launch-preprocessing', table.id);
    },
    onStartTableAnnotation: function (table) {
      console.log("[onStartTableAnnotation] -~~-> launch-annotation");
      this.$emit('launch-annotation', table.id);
    }
  }
};
</script>
<style scoped>


.clickable {
  cursor: pointer
}

</style>